import filterPages from 'shared/utils/filterPages'
import Page from 'shared/types/Page'
import Pages from 'components/AppRouter/Pages'

const getPages = (position?: String | false) => {

  let filteredPages: Page[]  = []
    
  if (typeof position != 'undefined')
    filteredPages = filterPages(Pages, position)
  else
    filteredPages = Pages

  return filteredPages
  
}

export default getPages
